import { Button } from "../button/button";
import { Container } from "../container/container";
import { Image } from "../image/image";
import { Text } from "../text/text";

export interface TeaserBannerProps {
  title: string;
  description: string;
  image: {
    src: string;
    alt: string;
  };
  button?: {
    text: string;
    href: string;
  };
  /**
   * Whether to apply Container wrapper for consistent spacing
   * @default true
   */
  fluid?: boolean;
}

export function TeaserBanner(props: TeaserBannerProps) {
  const fluid = props.fluid ?? true;

  const content = (
    <div className="group relative w-full overflow-hidden rounded-md border border-gray-200">
      {/* Background Image - Full container with rounded corners */}
      <div className="relative">
        {/* Mobile: 4:3 aspect ratio */}
        <div className="md:hidden">
          <Image
            alt={props.image.alt}
            aspectRatio="4:3"
            fill
            objectFit="cover"
            priority
            src={props.image.src}
          />
        </div>

        {/* Desktop: 16:9 aspect ratio */}
        <div className="hidden md:block">
          <Image
            alt={props.image.alt}
            aspectRatio="16:9"
            fill
            objectFit="cover"
            priority
            src={props.image.src}
          />
        </div>

        {/* Responsive gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent md:bg-gradient-to-r md:from-black/60 md:via-black/30 md:to-transparent" />
      </div>

      {/* Responsive content positioning */}
      <div className="absolute inset-0 z-10 flex h-full flex-col justify-center px-6 md:pl-[50px]">
        {/* Title */}
        <div className="mb-2">
          <Text color="white" variant="h2">
            {props.title}
          </Text>
        </div>

        {/* Description */}
        <div className="mb-[22px] max-w-[300px] font-normal">
          <Text color="white" variant="lead">
            {props.description}
          </Text>
        </div>

        {/* CTA Button */}
        {props.button && (
          <div>
            <Button href={props.button.href} size="default" variant="secondary">
              {props.button.text}
            </Button>
          </div>
        )}
      </div>
    </div>
  );

  return fluid ? <Container>{content}</Container> : content;
}
